import React from 'react';

const LiveTechBackground = () => (
  <div className="live-tech-background" aria-hidden="true">
    <div className="live-tech-grid" />
    <div className="live-tech-points" />
    <div className="live-pointer-light" />
    <div className="live-tech-glow live-tech-glow-one" />
    <div className="live-tech-glow live-tech-glow-two" />
    <div className="live-tech-orbit live-tech-orbit-one" />
    <div className="live-tech-orbit live-tech-orbit-two" />
    <div className="live-tech-scan" />
  </div>
);

export default LiveTechBackground;
